import {
    GET_LIST_CUSTOMER_STATUS,
    GET_SPECIFIC_CUSTOMER_STATUS,
    UPDATE_SPECIFIC_CUSTOMER_STATUS,
    CREATE_NEW_CUSTOMER_STATUS,
    REMOVE_CUSTOMER_STATUS,
    GET_CUSTOMER_STATUS_ACTIVE
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    customerStatusList: [],
    currentCustomerStatus: null,
    customerStatusActiveList: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_CUSTOMER_STATUS: {
            return {
                ...state,
                customerStatusList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_CUSTOMER_STATUS_ACTIVE: {
            return {
                ...state,
                customerStatusActiveList: action.payload.data,
            }
        }
        case GET_SPECIFIC_CUSTOMER_STATUS: {
            return { ...state, currentCustomerStatus: action.payload }
        }
        case CREATE_NEW_CUSTOMER_STATUS: {
            return {
                ...state,
                customerStatusList: [action.payload, ...state.customerStatusList],
                customerStatusActiveList: [action.payload, ...state.customerStatusActiveList],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_CUSTOMER_STATUS: {
            let index = state.customerStatusList.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.customerStatusList];
            temp[index] = action.payload;
            //
            let index2 = state.customerStatusActiveList.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp2 = [...state.customerStatusActiveList];
            temp[index2] = action.payload;

            return { ...state, customerStatusList: temp, customerStatusActiveList: temp2 }
        }
        case REMOVE_CUSTOMER_STATUS: {
            let temp = state.customerStatusList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });

            let temp2 = state.customerStatusActiveList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, customerStatusList: temp, customerStatusActiveList: temp2 }
        }
        default: return { ...state };
    }
}
